import { CommonModule } from '@angular/common';
import { Component, Inject, LOCALE_ID, inject } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule } from '@angular/forms';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { Router } from '@angular/router';
import { Labels } from '@core/constants/labels';
import { Image } from '@core/models/image.model';
import { IntegrationUpdate } from '@core/models/integration-update.model';
import { IntegrationUpdateService } from '@core/services/integration-update-service/integration-update-service.service';
import { Subscription } from 'rxjs';
import { LogViewComponent } from './components/components/log-view/log-view.component';
@Component({
  selector: 'app-integration-log',
  standalone: true,
  imports: [
    CommonModule,
    MatPaginatorModule,
    MatTableModule,
    MatDialogModule,
    FormsModule,
    MatChipsModule,
    MatProgressSpinnerModule,
    MatFormFieldModule,
    MatInputModule,
  ],
  templateUrl: './integration-log.component.html',
  styleUrl: './integration-log.component.scss',
})
export class IntegrationLogComponent {
  logList: IntegrationUpdate[] = [];
  dateRange: FormGroup;
  dataSource: MatTableDataSource<IntegrationUpdate>;

  labels_paginators = Labels.PAGINATORS;
  labels = Labels.INTEGRATION_LOG;
  count = 0;
  pageSize = 25;
  pageIndex = 0;
  hidePageSize = true;
  showFirstLastButtons = true;
  isDesktop = false;
  isMobile = false;

  loading = true;

  subscriptions = new Subscription();

  filterText = '';

  displayedColumns: string[] = ['image_name', 'exam_code', 'status', 'log'];

  imageTableColumns: string[] = ['image_name'];

  readonly dialog = inject(MatDialog);

  resourceStatus: any = null;
  resourceLogDatasource = new MatTableDataSource<IntegrationUpdate>([]);
  registeredImages = new MatTableDataSource<Image>([]);
  sameBlockImages = new MatTableDataSource<Image>([]);

  resourceCode = '';

  fullLogShown = false;

  constructor(
    private integrationUpdateService: IntegrationUpdateService,
    private fb: FormBuilder,
    private router: Router,
    @Inject(LOCALE_ID) private locale: string,
  ) {
    this.dataSource = new MatTableDataSource<IntegrationUpdate>([]);
    this.dateRange = this.fb.group({
      start: [null],
      end: [null],
    });
  }

  openExam(code: string) {
    this.router.navigate([`exam_view/${code}`]);
  }

  findResource() {
    const sub = this.integrationUpdateService
      .getResourceStatus(this.resourceCode)
      .subscribe((data) => {
        this.resourceStatus = data;
        if (data?.logs && data?.logs?.length > 0) {
          this.resourceLogDatasource =
            new MatTableDataSource<IntegrationUpdate>(
              data.logs.map((d: any) => d as IntegrationUpdate),
            );
        }

        if (data?.images) {
          this.registeredImages = new MatTableDataSource<Image>(data?.images);
        }

        if (data?.same_block_images) {
          this.sameBlockImages = new MatTableDataSource<Image>(
            data?.same_block_images,
          );
        }
      });
    this.subscriptions.add(sub);
  }

  fetchLog() {
    this.loading = true;
    const sub = this.integrationUpdateService
      .getIntegrationLog()
      .subscribe((data: any) => {
        this.logList = data.results;
        this.dataSource.data = data.results;
        this.count = data.count;
        this.loading = false;

        this.filterList();
      });
    this.subscriptions.add(sub);
  }

  filterList() {
    if (this.filterText === '') {
      this.dataSource.data = this.logList;
    } else {
      this.dataSource.data = this.logList.filter(
        (d) =>
          d.image_name.includes(this.filterText) ||
          d.exam_code.includes(this.filterText),
      );
    }
  }

  handlePageEvent(e: PageEvent) {
    this.pageSize = e.pageSize;
    this.pageIndex = e.pageIndex;
    this.integrationUpdateService.updateFilters(
      this.pageIndex + 1,
      this.pageSize,
    );
    this.fetchLog();
  }

  ngOnInit() {
    this.fetchLog();
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  getChipClass(update: IntegrationUpdate) {
    if (update.failed) return 'failed';

    try {
      const ret = this.labels.STATUS_LIST[update.status];
      if (ret !== undefined) {
        return ret.class;
      } else {
        return '';
      }
    } catch (err) {
      return '';
    }
  }

  getChipLabel(update: IntegrationUpdate) {
    if (update.failed) return this.labels.FAILED;

    try {
      const ret = this.labels.STATUS_LIST[update.status];
      if (ret !== undefined) {
        return ret.label;
      } else {
        return this.labels.UNKNOWN_STATUS;
      }
    } catch (err) {
      return this.labels.UNKNOWN_STATUS;
    }
  }

  openLog(infereceUpdate: IntegrationUpdate) {
    this.dialog.open(LogViewComponent, {
      data: { id: infereceUpdate.id },
    });
  }

  displayFullLog() {
    this.fullLogShown = true;
  }

  hideFullLog() {
    this.fullLogShown = false;
  }
}
